import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import DataContainer from "../../../../Utilities/DataContainer";
import RenderSelectField from "../../../../Utilities/Forms/RenderSelectField";
import RenderTextField from "../../../../Utilities/Forms/RenderTextField";
import ValidatedSelectElement from "../../../../Utilities/Forms/ValidatedSelectElement";
import ValidatedTextField from "../../../../Utilities/Forms/ValidatedTextField";
import monthDropdown from "../../../../Utilities/Constants/MonthDropdown";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";
import yesNoDropdown from "../../../../Utilities/Constants/YesNoDropdown";

interface IProps {
    groupDropdown: DropDownViewModel[] | [];
}
export default function MonitoringReportModeSplits({ groupDropdown }: IProps) {


    return (
        <Grid container>
            <Grid size={6}>
                <DataContainer title={"Pre-Travel Plan Mode Split"}>
                    <Stack spacing={1}>
                        <RenderSelectField label={"Was mode split data obtained before the introduction of the Travel Plan?"} options={yesNoDropdown} name={"modeSplitObtainedPrior"} readOnly={true} />
                        <Stack direction="row" spacing={1}>
                            <Grid size={4}>
                                <Typography variant={"body2"}>If yes, when was this sourced?</Typography>
                            </Grid>
                            <Grid size={4}>
                                <ValidatedSelectElement name={'modeSplitMonth'} options={monthDropdown} readOnly={true} />
                            </Grid>
                            <Grid size={4}>
                                <ValidatedTextField name={'modeSplitYear'} readOnly={true} />
                            </Grid>
                        </Stack>
                        <Stack direction={"row"}>
                            <Grid size={6}>
                                <Stack spacing={1}>
                                    <RenderTextField label={"Vehicle Occupants"} name={"modeSplitVehicle"} readOnly={true} />
                                    <RenderTextField label={"Cyclists"} name={"modeSplitCyclist"} readOnly={true} />
                                    <RenderTextField label={"Public Transport Users"} name={"modeSplitPublicTransport"} readOnly={true} />
                                    <RenderTextField label={"Pedestrians"} name={"modeSplitPedestrians"} readOnly={true} />
                                </Stack>
                            </Grid>
                            <Grid size={6}>
                                {/*PIE CHART HERE*/}
                            </Grid>
                        </Stack>
                    </Stack>
                </DataContainer>
            </Grid>

            <Grid size={6}>
                <DataContainer title={"Travel Plan Mode Split Targets"}>
                    <Stack spacing={1}>
                        <RenderSelectField label={"Did the Travel Plan identify mode split targets?"} options={yesNoDropdown} name={"targetsIdentified"} readOnly={true} />
                        <Grid size={12}>
                        </Grid>
                        <Stack direction="row" spacing={1}>
                            <Grid size={4}>
                                <Typography variant={"body2"}>If YES, when were these targets identified?</Typography>
                            </Grid>
                            <Grid size={4}>
                                <ValidatedSelectElement name={'targetsMonth'} options={monthDropdown} readOnly={true} />
                            </Grid>
                            <Grid size={4}>
                                <ValidatedTextField name={'targetsYear'} readOnly={true} />
                            </Grid>
                        </Stack>
                        <Stack direction={"row"}>
                            <Grid size={6}>
                                <Stack spacing={1}>
                                    <RenderTextField label={"Vehicle Occupants"} name={"targetsVehicle"} readOnly={true} />
                                    <RenderTextField label={"Cyclists"} name={"targetsCyclist"} readOnly={true} />
                                    <RenderTextField label={"Public Transport Users"} name={"targetsPublicTransport"} readOnly={true} />
                                    <RenderTextField label={"Pedestrians"} name={"targetsPedestrians"} readOnly={true} />
                                </Stack>
                            </Grid>
                            <Grid size={6}>
                                {/*PIE CHART HERE PLEASE*/}
                            </Grid>
                        </Stack>
                    </Stack>
                </DataContainer>
            </Grid>

            <Grid size={6}>
                <DataContainer title={"Target Groups"}>
                    <Stack spacing={1}>
                        <RenderSelectField label={"Staff"} options={groupDropdown} name={"targetGroupStaff"} readOnly={true} />
                        <RenderSelectField label={"Visitors"} options={groupDropdown} name={"targetGroupVisitors"} readOnly={true} />
                        <RenderSelectField label={"Customers"} options={groupDropdown} name={"targetGroupCustomers"} readOnly={true} />
                        <RenderSelectField label={"Students"} options={groupDropdown} name={"targetGroupStudents"} readOnly={true} />
                        <RenderSelectField label={"Patients"} options={groupDropdown} name={"targetGroupPatients"} readOnly={true} />
                        <RenderSelectField label={"All Site Users"} options={groupDropdown} name={"targetGroupAllSiteUsers"} readOnly={true} />
                        <RenderSelectField label={"Other"} options={groupDropdown} name={"targetGroupOther"} readOnly={true} />
                        <RenderTextField label={"Other Specified"} name={"targetGroupOtherText"} readOnly={true} />
                    </Stack>
                </DataContainer>
            </Grid>

            <Grid size={6}>
                <DataContainer title={"Comments"}>
                    <Stack spacing={1}>
                        <RenderTextField name={"comments"} multiline rows={4} readOnly={true} />
                    </Stack>
                </DataContainer>
            </Grid>
        </Grid>
    );
}